export default __webpack_public_path__ + "static/media/Ico_btn_portalsiniestro.5c10851d.svg";